<template>
  <div class="tagList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        placeholder="请输入纬度名称"
        size="small"
        v-model="params.content"
        class="param-input"
        clearable
        @keyup.enter.native="getTagList"
      ></el-input>
      <el-select v-model="params.kind" placeholder="请选择种类" size="small" clearable>
        <el-option v-for="k in kinds" :key="k.value" :label="k.label" :value="k.value">
        </el-option>
      </el-select>
      <el-button type="primary" size="small" @click="getTagList">搜索</el-button>
      <el-button type="primary" size="small" @click="tagsAction('add')">+新增纬度</el-button>
    </div>
    <!--数据表格-->
    <el-table
      height="620"
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      @sort-change="handleSortChange"
    >
      <el-table-column prop="id" label="ID" align="center" width="220" fixed></el-table-column>
      <el-table-column
        prop="name"
        label="名称"
        align="center"
        width="300"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-tag type="success" size="mini" effect="plain" class="tags">{{'#' + scope.row.name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="kind" label="种类" align="center" width="300" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-tag type="success" size="mini" effect="plain" class="tags">
            {{ scope.row.kind | handlKind }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="纬度排序" align="center" width="200" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{scope.row.sort || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button type="success" class="el-icon-edit" size="mini" @click="tagsAction('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" @click="delTable(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30, 50]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--新增、编辑tag弹窗-->
    <tag-action ref="tagAction" @handlerTagList="handlerTagList"></tag-action>
  </div>
</template>
<script>
import TagAction from "./components/addDimension";
import { sortEscape } from "@/utils/global";
import API from "@/api";

export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        content: "",
        key: "",
        value: "",
        filterValue: 0,
        kind: undefined,
      },
      kinds: [
        { label: "电影", value: 0 },
        { label: "剧集", value: 1 },
        { label: "综艺", value: 2 },
        { label: "动漫", value: 3 },
      ],
    };
  },
  components: {
    TagAction
  },
  created() {
    this.getTagList();
  },
  methods: {
    // 请求tag列表数据
    getTagList(type) {
      if (type) {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getMediaTagDimensionList(this.params)
        .then(res => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.params.value = sortEscape(column.order);
        this.params.key = column.prop;
      } else {
        this.params.value = "";
        this.params.key = "";
      }
      this.getTagList();
    },
    // 分页条数发生变化时触发
    changeSize(number) {
      this.params.pageSize = number;
      this.getTagList();
    },
    // 当前页发生变化时触发
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getTagList();
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerTagList() {
      this.params.pageNumber = 1;
      this.params.pageSize = 5;
      this.getTagList();
    },
    // 新增、编辑tags
    tagsAction(type, data) {
      this.$refs.tagAction.open(type, data);
    },
    // 删除纬度
    delTable(row) {
      if (row.isActive === true) {
      this.$message.error('当前纬度为开启状态，不能删除！')
        return false
      }
      this.$confirm('您确定要删除当前纬度吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          API.deleteMediaTagDimensions({ id: [row.id] }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.getTagList()
            } else {
              this.$message.error('删除失败！');
            }
          })
        })
    },
  }
};
</script>


